export default "__VITE_ASSET__SH0uIFYJ__"